// Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams, HttpResponseBase } from '@angular/common/http';

// Environment
import { environment } from 'environments/environment';

// Http Context
import { BYPASS, CIP } from 'app/auth/helpers';

// Models
import * as models from 'app/auth/models/index';

// RxJS
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserService {
  constructor(private _http: HttpClient) {}

  getGeneralAccounts(): Observable<models._User.UserInfo[]> {
    return this._http
      .get<models._User.UserInfo[]>(environment.apiUrl + '/api-vlight/accounts', {
        observe: 'response',
        context: new HttpContext().set(CIP, false),
      })
      .pipe(
        map((httpResponse) => httpResponse.body),
        map((users) => users.sort((a, b) => (b.nombreCompleto > a.nombreCompleto ? -1 : 1)))
      );
  }

  getDevices(): Observable<models._User.Device[]> {
    return this._http
      .get<{ devices: models._User.Device[] }>(environment.apiUrl + '/api-vlight/device/list', {
        observe: 'response',
      })
      .pipe(map((httpResponse) => httpResponse.body.devices));
  }

  createNewAccount(data: models._User.NewAccountProperties): Observable<models._User.AccessFile> {
    return this._http
      .post<models._User.AccessFile>(
        environment.apiUrl + '/api-vlight/master/account',
        {
          email: data.email,
          displayName: data.displayName,
          center: data.center,
        },
        {
          observe: 'response',
          params: new HttpParams().set('role', data.role).set('force', data.force),
          context: new HttpContext().set(CIP, false),
        }
      )
      .pipe(map((httpResponse) => httpResponse.body));
  }

  editNameOrStatus(data: models._Edit.Name | models._Edit.Status): Observable<HttpResponseBase> {
    return this._http.patch<HttpResponseBase>(
      environment.apiUrl + '/api-vlight/master/account/simple',
      {
        _id: data.idAccount,
        value: data.value,
      },
      {
        observe: 'response',
        params: new HttpParams().set('param', data.param),
        context: new HttpContext().set(CIP, false),
      }
    );
  }

  generateNewAccessFile(accountID: string): Observable<models._User.AccessFile> {
    return this._http
      .get<models._User.AccessFile>(environment.apiUrl + '/api-vlight/master/account/key', {
        observe: 'response',
        params: new HttpParams().set('_id', accountID),
        context: new HttpContext().set(CIP, false),
      })
      .pipe(map((httpResponse) => httpResponse.body));
  }

  editCentersAccount(accountID: string, centerID: string, type: 'eliminar' | 'agregar'): Observable<HttpResponseBase> {
    return this._http
      .patch<HttpResponseBase>(
        environment.apiUrl + '/api-vlight/master/account/center',
        {
          _id: accountID,
          center: centerID,
        },
        {
          observe: 'response',
          params: new HttpParams().set('action', type),
          context: new HttpContext().set(CIP, false),
        }
      )
      .pipe(map((httpResponse) => httpResponse.body));
  }

  createInvitationDevice(uid: string): Observable<HttpResponseBase> {
    return this._http
      .post<HttpResponseBase>(environment.apiUrl + '/api-vlight/device/invitation', { uid }, { observe: 'response' })
      .pipe(map((httpResponse) => httpResponse.body));
  }

  deleteDevice(uid: string): Observable<HttpResponseBase> {
    return this._http
      .delete<HttpResponseBase>(environment.apiUrl + '/api-vlight/device', {
        observe: 'response',
        params: new HttpParams().set('device', uid),
      })
      .pipe(map((httpResponse) => httpResponse.body));
  }
}
